<div class="contacts" id="contacts-table">
	<contacts-analytics></contacts-analytics>
	<h1 class="contacts__title">{{ 'CONTACT.CONTACTS' | translate }}</h1>
	<freud-card>
		<contacts-inactives-banner></contacts-inactives-banner>
		<div class="contacts__header">
			<div>
				<freud-checkbox
					*ngIf="contacts.length > 0 && !isLoading"
					[(ngModel)]="isAllContactsSelected"
					(onChange)="toggleSelectedContacts($event)"
					label="Selecionar todos"
				></freud-checkbox>
			</div>
			<div class="contacts__header-right">
				<freud-input-text
					class="contacts__search"
					[(ngModel)]="search"
					(valueChange)="onSearchChange()"
					[placeholder]="'CONTACT.SEARCH_PLACEHOLDER' | translate"
					rightIcon="freud-icon-search"
				></freud-input-text>
				<div class="zk-flex zk-items-center zk-gap-2 contacts__order-by">
					<span class="order-by__label">{{
						'CONTACT.ORDER_BY' | translate
					}}</span>
					<freud-select
						[(ngModel)]="orderBy"
						[options]="orderOptions"
						[placeholder]="'CONTACT.SELECT' | translate"
						(onChange)="onOrderByChange()"
					>
					</freud-select>
				</div>
				<freud-button color="secondary" (click)="addContact()">
					<div class="zk-flex zk-gap-3 zk-items-center">
						<span>{{ 'CONTACT.ADD_CONTACT' | translate }}</span>
						<span class="freud-icon freud-icon-md freud-icon-plus"></span>
					</div>
				</freud-button>
				<div class="zk-relative">
					<div class="filter__quantity" *ngIf="selectedFiltersQuantity > 0">
						{{selectedFiltersQuantity}}
					</div>
					<freud-button color="secondary" icon="freud-icon freud-icon-sliders-h"
						(keyup)="$event.key === 'Enter' ? openFilterSidebar() : null" (click)="openFilterSidebar()">
					</freud-button>
					</div>
			</div>
		</div>
		<contacts-table
			[loading]="isLoading"
			[contacts]="contacts"
			(onScheduleClick)="openAppoitmentSidebar($event)"
			(onToggleContact)="onToggleSingleSelectedContact($event)"
		></contacts-table>
		<freud-paginator
			*ngIf="!isLoading && totalContacts > 1"
			[pageLinkSize]="totalPages"
			[rows]="30"
			[first]="currentPage * 30 - 30"
			[totalRecords]="totalContacts"
			[showFirstLastIcon]="false"
			(onPageChange)="onPageChange($event)"
		></freud-paginator>
	</freud-card>
</div>
<contact-bulk-actions
	*ngIf="selectedContacts.length > 0"
	[selectedContacts]="selectedContacts"
	(onSendMessage)="cleanSelectedContacts()"
></contact-bulk-actions>
<appointment-sidebar></appointment-sidebar>
<contacts-table-filters-sidebar
	[professionalType]="professionalType"
	(onCloseSidebar)="onCloseFilterSidebar()"
	(onFilter)="onSearchChange($event)"
	(onChangeQuantity)="this.selectedFiltersQuantity = $event"
	[isOpen]="contactFilterIsVisible"
>
</contacts-table-filters-sidebar>